// TODO change all to pascal case

import { AvailableCandlestickResolutions } from '@constants/coin';

export type SugarMoneyApiCoinMetadataType = {
  name: string;
  symbol: string;
  description: string;
  twitter?: string;
  website?: string;
};

export type SugarMoneyApiPostIpfsMetadataRequestType = {
  coinData: SugarMoneyApiCoinMetadataType;
  image: File;
};

export type SugarMoneyApiPostIpfsMetadataResponseType = {
  ipfsUrl: string;
  ipfsImgUrl: string;
};

export type SugarMoneyApiPostCoinRequestType = {
  image: File;
  metadata: SugarMoneyApiCoinMetadataType;
  migrationInPsol: boolean;
};

export type SugarMoneyApiPostSignTransactionRequestType = {
  serialisedTx: string;
  mint: string;
  blockhash: string;
  lastValidBlockHeight: number;
};

export type SugarMoneyApiPostSignTransactionResponseType = {
  signature: string;
};

export enum SugarMoneyApiCoinMetadataOperationEnum {
  CoinCreationViaApi = 'coin-creation-via-api',
  IpfsUrlForMetadata = 'ipfs-url-for-metadata',
}

export enum SugarMoneyApiCoinMetadataStatusEnum {
  Processing = 'processing',
  Complete = 'complete',
}

export type SugarMoneyApiPostCoinMetadataResponse =
  | {
      status: SugarMoneyApiCoinMetadataStatusEnum.Processing;
      receivedChunks: number[];
      totalChunks: number;
      fileId: string;
    }
  | {
      ipfsUrlOriginalImage: string;
      ipfsUrlCompressedImage: string;
      ipfsUrlMetadata: string;
      fileId: string;
      status: SugarMoneyApiCoinMetadataStatusEnum.Complete;
    }
  | string;

export type SugarMoneyApiAddressRequestType = {
  address: string;
  page?: number;
  limit?: number;
};

export type SugarMoneyApiCoinResponseType = {
  address: string;
  coinSymbol: string;
  coinName: string;
  coinSrc: string;
  coinCreationTime: number;
  coinMarketCap: number;
  username: string;
  holders: number;
  comments: number;
  xUrl: string | null;
  websiteUrl: string | null;
  featured: boolean;
  coinAmount: string;
  solPrice: string;
  solAmount: string;
  bondingCurve: string;
  creator: string;
  coinDescription: string | null;
  nsfw: boolean;
  metadataIpfsUrl?: string;
  bondingCurveComplete?: boolean;
  bondingCurveProgress: number;
  raydiumPoolAddress?: string | null;
  largestTradeSolAmount: string;
  largestTradeUsdAmount: string;
  signature: string | null;
  volumeSol: string;
  volumeUsd: string;
  migrationInPsol: boolean;
  migratedToRaydiumAt: string | null;
};

export type SugarMoneyApiCoinCommentResponseType = {
  message: string | null;
  imageUri: string | null;
  createdAt: string;
  id: number;
  user: {
    username: string | null;
    image: string | null;
    publicKey: string;
  };
};

export type SugarMoneyApiTradesResponseType = {
  publicKey: string;
  isBuy: boolean;
  time: number;
  price: string;
  amount: number;
  totalUsd: number;
  signature: string;
  solAmount: number;
};

export type CoinHoldersResponseType = {
  data: {
    user: string;
    total: string;
  }[];
  updatedAt: number;
};

export type SugarMoneyApiCoinMintResponseType = string;

export type SugarMoneyApiCoinFavoriteResponseType = boolean;

export type SugarMoneyApiCoinUnFavoriteResponseType = boolean;

export type SugarMoneyApiAvailableCandlestickResolutionType =
  (typeof AvailableCandlestickResolutions)[number];

export type SugarMoneyApiCandlestickDataResponseType = Array<{
  time: number;
  open: number;
  high: number;
  low: number;
  close: number;
  volume: number;
  trade_count: number;
}>;

export type SugarMoneyApiCommentRequestType = {
  address: string;
  comment: string;
};

export type SugarMoneyApiCommentResponseType = {
  id: number;
  mint: string;
  message: string;
  userId: string;
  createdAt: string;
};
